module.exports = "pegasus/assets/theme2/l_w.png";